export const useConnectionSpeed = (): number | null => {
  if (typeof window !== "undefined" && (window as any).navigator?.connection) {
    return (window as any).navigator.connection.downlink || null;
  }
  return null;
};
